const firebaseConfig = {
    // apiKey: "AIzaSyBYK_8VwTieHIk3INW9_7_ip1bu8zPB3Mk",
    // authDomain: "health-care-diagnostic-center.firebaseapp.com",
    // projectId: "health-care-diagnostic-center",
    // storageBucket: "health-care-diagnostic-center.appspot.com",
    // messagingSenderId: "936126442283",
    // appId: "1:936126442283:web:42a16f273d3655a392336e"
    apiKey: "AIzaSyBygtULm-MCEjCEl1NNVf8wfLpINMpcw0M",
    authDomain: "health-care-24dae.firebaseapp.com",
    projectId: "health-care-24dae",
    storageBucket: "health-care-24dae.appspot.com",
    messagingSenderId: "640071737708",
    appId: "1:640071737708:web:bbdce94708e4a35c76d349"
};

export default firebaseConfig;